import {
  ICalculationStatement,
  ICalculationStatementUpdate,
} from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

interface IProps {
  calculationId: string;
  statementId?: string;
  payload: ICalculationStatementUpdate;
}

export const upsertCalculationStatement = ({
  calculationId,
  statementId,
  payload,
}: IProps): Promise<ICalculationStatement> => {
  if (statementId === undefined) {
    return API.post(`api/accommodation/calculations/${calculationId}/statements`, payload).then(
      response => response?.data,
    );
  }

  return API.put(`api/accommodation/calculations/statements/${statementId}`, payload).then(
    response => response?.data,
  );
};
